import { FormControl, FormControlLabel, Grid } from '@mui/material';
import { AccordionGeneralityForm } from 'civil-status/view-models/accordion-generality-form';
import { memo, useCallback } from 'react';
import { FormikErrors, FormikTouched } from 'formik';
import Italian from '../../../shared/italian';
import { ItalianForm } from 'shell/view-models/italian-form';
import { RadioGroup } from '@mui/material';
import { Radio } from '@mui/material';
import Foreign from '../../../shared/foreign';
import { ForeignForm } from 'civil-status/view-models/accordion-generality-form';

interface BornNascita03ComponentProps {
  disabled?: boolean;
  generality?: AccordionGeneralityForm;
  errorsGenerality?: FormikErrors<AccordionGeneralityForm>;
  touchedGenerality?: FormikTouched<AccordionGeneralityForm>;
  onChangeGenerality: (
    key: keyof AccordionGeneralityForm,
    value: AccordionGeneralityForm[keyof AccordionGeneralityForm]
  ) => void;
  onChangeFieldsGenerality: (values: AccordionGeneralityForm) => void;
}

const BornNascita03Component = ({
  disabled = false,
  generality,
  errorsGenerality,
  touchedGenerality,
  onChangeGenerality,
  onChangeFieldsGenerality,
}: BornNascita03ComponentProps): React.ReactElement => {
  const onFieldItalianChange = useCallback(
    (key, value) => {
      onChangeGenerality('italian', {
        ...(generality || {}).italian,
        [key]: value,
      });
    },
    [generality, onChangeGenerality]
  );

  const onFieldsItalianChange = useCallback(
    (valuesNew) => {
      onChangeGenerality('italian', {
        ...(generality || {}).italian,
        ...valuesNew,
      });
    },
    [generality, onChangeGenerality]
  );

  const onFieldForeignChange = useCallback(
    (key, value) => {
      onChangeGenerality('foreign', {
        ...(generality || {}).foreign,
        [key]: value,
      });
    },
    [generality, onChangeGenerality]
  );

  const onFieldsForeignChange = useCallback(
    (value) => {
      onChangeGenerality('foreign', {
        ...(value || {}),
      });
    },
    [generality, onChangeGenerality]
  );

  return (
    <Grid container spacing={2} item>
      <Grid item xs={12}>
        <FormControl component="fieldset">
          <RadioGroup
            row
            aria-label="Nascita"
            id="isForeignBorn"
            value={generality?.isForeignBorn || 'false'}
            onChange={() => {
              onChangeFieldsGenerality({
                isForeignBorn: !generality?.isForeignBorn,
                italian: {
                  location: '',
                  province: '',
                  municipality: null,
                },
                foreign: {
                  state: null,
                  province: '',
                  municipality: null,
                },
              });
            }}
          >
            <FormControlLabel
              value="false"
              control={<Radio />}
              label="Nascita Italia"
              disabled={disabled}
            />
            <FormControlLabel
              value="true"
              control={<Radio />}
              label="Nascita Estero"
              disabled={disabled}
            />
          </RadioGroup>
        </FormControl>
      </Grid>
      {!generality?.isForeignBorn ? (
        <Italian
          disabledComponent={disabled}
          values={generality?.italian}
          onChange={onFieldItalianChange}
          onChanges={onFieldsItalianChange}
          fromDate={generality?.birthDate || null}
          errors={errorsGenerality?.italian as FormikErrors<ItalianForm>}
          touched={touchedGenerality?.italian as unknown as FormikTouched<ItalianForm>}
          required
          idDominio={generality?.birthPlaceItem?.idDominio}
          idValore={generality?.birthPlaceItem?.idValore}
        />
      ) : (
        <Foreign
          disabledComponent={disabled}
          values={generality?.foreign}
          onChange={onFieldForeignChange}
          onChanges={onFieldsForeignChange}
          errors={errorsGenerality?.foreign as FormikErrors<ForeignForm>}
          touched={touchedGenerality?.foreign as unknown as FormikTouched<ForeignForm>}
          required
          isBirth
        />
      )}
    </Grid>
  );
};

BornNascita03Component.displayName = 'Form generality BORN component- BornNascita03 ';

const BornNascita03 = memo(BornNascita03Component);

export default BornNascita03;
